import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import HeatMap from "../../components/HeatMaps2"


const MoreReportPage = () => {
  const positions = [
    "top-10 right-48",
    "top-[230px] right-[360px]",
    "top-[320px] right-[560px]",
    "top-[420px] right-[410px]",
    "bottom-[450px] left-[480px]",
    "bottom-[500px] right-[160px]",
    "bottom-[130px] left-1/3",
    "bottom-[200px] right-[480px]",
  ]

  return (
    <div className='bg-white'>
    
      <HeatMap />
      <div className='md:px-[7%] px-4'>
      <div
      className="flex items-center justify-between md:h-[91px] h-[40px] px-6 md:mb-10 shadow-[#00000040] shadow-md border-b-[2px] border-[#00000040]" 
      style={{
        backgroundColor: '#152C24',
        borderBottomRightRadius: '5px',
        borderBottomLeftRadius: '5px',
      }}
    >
      {/* Logo + Phone Number */}
      <div className="flex items-center space-x-4">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745108283/FarmNet_Logo_Green_3_l7jdrz.png"
          alt="FarmNet Logo"
          className="md:h-8 h-2"
        />
        <span className="text-white font-extrabold text-[8px] md:text-[24px] font-poppins">
          +254702157000
        </span>
      </div>

      {/* Divider */}

      {/* Website URL */}
      <span className="text-white font-bold text-[8px] md:text-[24px] font-poppins ">
     |   www.farmersnetworks.africa
      </span>
    </div>
    <div className="md:h-4 h-2"></div>
      </div>
    </div>
  )
}

export default MoreReportPage
